import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames';
import moment from 'moment';
import {Tree} from 'antd';
import { showModal, MODAL_FOLDER_FORM, MODAL_FOLDER_DELETE } from '../../../../modules/modals';
import ButtonPanel from '../../../QbmPage/ButtonPanel';
import { getFolders, setFolderItem, getFolderPresentation } from '../../actions';
import {findIndex} from 'lodash';
import Spiner from '../../../helpers/Spiner/Spiner';
const { TreeNode, DirectoryTree } = Tree;

class Folders extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  state = {
    loaded_folders: false,
  }
  async componentDidMount(){
    await this.props.getFolders();
    this.setState({loaded_folders: true})
  }


  onSelect = (key, event) => {
    console.log("🚀 ~ file: Foleders.jsx ~ line 26 ~ Folders ~ key", key, event)
    const { folders, folder } = this.props;

    const item = folders.find(_i => _i.id == key);
    if(item){
      this.props.setFolderItem(item);
      this.props.getFolderPresentation(item.id);
    }
    return false
  }

  render() {
    const {formatMessage} = this.context;
    const { folders, folder } = this.props;
    const {loaded_folders} = this.state;

    if(!loaded_folders){
      return <div className="qbm-accordion-panel folders">
      <div className="qbm-accordion-component">
        <div className="qbm-accordion-title">
          {formatMessage('titlePresentationFolder')}
        </div>
        <div className="posr qbm-accordion-body open">
          <div className="qbm-accordion-content">
            <Spiner/>
          </div>
        </div>
        </div>
      </div>
    }

    const tmp_folders = [];

    folders.forEach(item => {
      if(!item.parent_id) {
        tmp_folders.push({...item, children: []});
      }
    });

    folders.forEach(item => {
      let index = findIndex(tmp_folders, ['id', parseInt(item.parent_id)])
      if(item.parent_id && index > -1) {
        tmp_folders[index].children.push(item);
      }
    });

    return (
      <div className="qbm-accordion-panel folders">
        <div className="qbm-accordion-component">
          <div className="qbm-accordion-title">
            {formatMessage('titlePresentationFolder')}
          </div>
          <div className="posr qbm-accordion-body open">
            <div className="qbm-accordion-content">
            <DirectoryTree onSelect={this.onSelect}>
              {tmp_folders.map(item => <TreeNode icon={<i className="fas fa-folder"></i>} title={item.title} key={item.id}>
                {item.children.map(ch => <TreeNode icon={<i className="fas fa-folder"></i>} title={ch.title} key={ch.id} />)}
              </TreeNode>)}
            </DirectoryTree>
              {/* {tmp_folders.map(item => ([
                <div
                  key={`folder-item-${item.id}`}
                  className={classNames("qbm-accordion-content__item ", {'qbm-accordion-content__item--selected': folder && folder.id == item.id ? true : false})}
                  onClick={() => {
                    this.props.setFolderItem(item);
                    this.props.getFolderPresentation(item.id);
                  }}
                >
                  <i className="fas fa-folder"></i> <span className="text-ellipsis">{item.title}</span> 
                </div>,
                ...item.children.map(ch => 
                  <div
                    key={`folder-item-${ch.id}`}
                    className={classNames("qbm-accordion-content__item", 'child', {'qbm-accordion-content__item--selected': folder && folder.id == ch.id ? true : false})}
                    onClick={() => {
                      this.props.setFolderItem(ch);
                      this.props.getFolderPresentation(ch.id);
                    }}
                  >
                    <i className="fas fa-folder"></i> <span className="text-ellipsis">{ch.title}</span> 
                  </div>
                )
              ]))} */}
            </div>
            <ButtonPanel
              handleAddCreateClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_FOLDER_FORM,
                  modalProps : {
                    initialValues: {
                    }
                  }
                });
              }}
              handleDeleteClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_FOLDER_DELETE,
                  modalProps : {
                    folder_id: folder.id
                  }
                });
              }}
              handleUpdateClick = {() => {
                const { showModal } = this.props;
                if(folder){
                  showModal({
                    modalType : MODAL_FOLDER_FORM,
                    modalProps : {
                      initialValues: {
                        ...folder, 
                      }
                    }
                  });
                }
              }}
              isUpdateActive = {!!folder}
              isDeleteActive = {!!folder}
            />
          </div>
          
        </div>
        
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  folders: state.folders.list,
  folder: state.folders.item,
})

const mapDispatchToProps = {
  showModal,
  getFolders,
  setFolderItem,
  getFolderPresentation,
}

export default connect(mapStateToProps, mapDispatchToProps)(Folders)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/Folders/Foleders.jsx